const inline = (text) =>
  text.split(/(\*\*[^*]+\*\*|\[\d+\])/g).map((part, i) => {
    if (part.startsWith("**") && part.endsWith("**")) return <strong key={i} className="font-semibold text-foreground">{part.slice(2, -2)}</strong>;
    if (/^\[\d+\]$/.test(part)) return <sup key={i} className="text-primary font-mono text-[10px] ml-0.5">{part}</sup>;
    return part;
  });

export const Markdown = ({ text, testId }) => {
  const blocks = [];
  let list = null;
  (text || "").split("\n").forEach((raw, i) => {
    const line = raw.trimEnd();
    const bullet = line.match(/^\s*[-*]\s+(.*)/);
    if (bullet) {
      if (!list) { list = []; blocks.push({ type: "ul", items: list, key: i }); }
      list.push({ text: bullet[1], indent: /^\s{2,}/.test(raw) });
      return;
    }
    list = null;
    if (/^#{1,3}\s/.test(line)) blocks.push({ type: "h", text: line.replace(/^#+\s/, ""), key: i });
    else if (line.trim()) blocks.push({ type: "p", text: line, key: i });
  });
  return (
    <div data-testid={testId} className="space-y-3 text-sm leading-relaxed">
      {blocks.map((b) =>
        b.type === "h" ? (
          <h3 key={b.key} className="label-caps text-primary pt-3 first:pt-0">{b.text}</h3>
        ) : b.type === "ul" ? (
          <ul key={b.key} className="space-y-1.5">
            {b.items.map((it, j) => (
              <li key={j} className={`flex gap-2 ${it.indent ? "ml-5 text-muted-foreground" : ""}`}>
                <span className="mt-2 h-1 w-1 rounded-full bg-primary shrink-0" />
                <span>{inline(it.text)}</span>
              </li>
            ))}
          </ul>
        ) : (
          <p key={b.key} className="text-muted-foreground">{inline(b.text)}</p>
        )
      )}
    </div>
  );
};
